import React, { useState, useEffect } from 'react';
import { format, startOfMonth, endOfMonth, eachDayOfInterval, getMonth, getYear, isToday } from 'date-fns';
import { es } from 'date-fns/locale';
import { getMonthStatus } from '../api';
import './MonthView.css';

const MonthView = () => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [monthStatus, setMonthStatus] = useState([]);

  useEffect(() => {
    loadMonthStatus();
  }, [currentDate]);

  const loadMonthStatus = async () => {
    try {
      const year = getYear(currentDate);
      const month = getMonth(currentDate) + 1;
      const response = await getMonthStatus(year, month);
      setMonthStatus(response.data);
    } catch (error) {
      console.error('Error cargando estado del mes:', error);
    }
  };

  const monthStart = startOfMonth(currentDate);
  const monthEnd = endOfMonth(currentDate);
  const days = eachDayOfInterval({ start: monthStart, end: monthEnd });

  const getStatusColor = (status) => {
    switch (status) {
      case 'complete':
        return '#d4edda'; // Verde
      case 'partial':
        return '#fff3cd'; // Amarillo
      case 'empty':
        return '#f8d7da'; // Rojo
      default:
        return '#f5f5f5';
    }
  };

  const getStatusBorder = (status) => {
    switch (status) {
      case 'complete':
        return '2px solid #28a745';
      case 'partial':
        return '2px solid #ffc107';
      case 'empty':
        return '2px solid #dc3545';
      default:
        return '1px solid #e0e0e0';
    }
  };

  const getStatusForDate = (date) => {
    const dateStr = format(date, 'yyyy-MM-dd');
    const statusItem = monthStatus.find(item => {
      const itemDateStr = typeof item.date === 'string' ? item.date : format(new Date(item.date), 'yyyy-MM-dd');
      return itemDateStr === dateStr;
    });
    return statusItem ? statusItem.status : 'empty';
  };

  const handlePreviousMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1));
  };

  const handleNextMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1));
  };

  // Obtener el primer día de la semana del mes
  const firstDayOfWeek = monthStart.getDay();
  const adjustedFirstDay = firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1; // Lunes = 0

  return (
    <div className="month-view">
      <div className="month-navigation">
        <button onClick={handlePreviousMonth} className="btn-nav">←</button>
        <h2>{format(currentDate, 'MMMM yyyy', { locale: es })}</h2>
        <button onClick={handleNextMonth} className="btn-nav">→</button>
      </div>

      <div className="month-legend">
        <div className="legend-item">
          <div className="legend-color" style={{ backgroundColor: '#d4edda', border: '2px solid #28a745' }}></div>
          <span>Completo (comida y cena)</span>
        </div>
        <div className="legend-item">
          <div className="legend-color" style={{ backgroundColor: '#fff3cd', border: '2px solid #ffc107' }}></div>
          <span>Parcial (falta comida o cena)</span>
        </div>
        <div className="legend-item">
          <div className="legend-color" style={{ backgroundColor: '#f8d7da', border: '2px solid #dc3545' }}></div>
          <span>Vacío (sin configurar)</span>
        </div>
      </div>

      <div className="month-calendar">
        <div className="calendar-header">
          {['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'].map((day) => (
            <div key={day} className="calendar-day-header">
              {day}
            </div>
          ))}
        </div>
        <div className="calendar-grid">
          {Array.from({ length: adjustedFirstDay }).map((_, i) => (
            <div key={`empty-${i}`} className="calendar-day empty"></div>
          ))}
          {days.map((day) => {
            const status = getStatusForDate(day);
            const isTodayDay = isToday(day);
            return (
              <div
                key={format(day, 'yyyy-MM-dd')}
                className={`calendar-day ${isTodayDay ? 'today' : ''}`}
                style={{
                  backgroundColor: getStatusColor(status),
                  border: getStatusBorder(status),
                }}
              >
                <div className="day-number">{format(day, 'd')}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MonthView;

